import { getStorage, isValidStorageKey } from '~/src/common/storage';

export function rememberCloseBannerTime(storageKey: string, currentTimeInMs: number) {
  if (isValidStorageKey(storageKey)) {
    const storage = getStorage();
    storage.setItem(storageKey, String(currentTimeInMs));
  } else {
    console.warn('Site Wide Banner: Invalid storage key, banner will shown after every reload');
  }
}
